/* eslint-disable @typescript-eslint/naming-convention */
import { LicenseType } from "#/apis/infra/getLicense";
import { TraceDetailType } from "#/apis/infra/getTraceDetail";
import { DashboardItem } from "#/apis/infra/getDashboard";
import { PolicyNameMapping } from "#/apis/infra/getPolicyNameMapping";
import { MaliciousRequest } from "#/types/xecguard";

export const initTraceRecordsState = {
  loading: false,
  records: [] as MaliciousRequest[],
  hasNext: false,
  nextCursor: undefined as string | undefined,
};

export const initState = {
  license: {
    loading: false,
    results: null,
  },
  unsafeRequests: {
    loading: false,
    results: null,
  },
  statsSummary: {
    loading: false,
    results: null as { request_unsafe_count: number } | null,
  },
  traceRecords: { ...initTraceRecordsState },
  traceDetail: {
    loading: false,
    results: null,
  },
  dashboardData: {
    loading: false,
    results: null,
  },
  policyNameMapping: {
    loading: false,
    results: null,
  },
};

export type TraceRecordsStateType = {
  loading: boolean;
  records: MaliciousRequest[];
  hasNext: boolean;
  nextCursor: string | undefined;
};

export type DashboardStateType = {
  license: {
    loading: boolean;
    results: LicenseType | null;
  };
  unsafeRequests: {
    loading: boolean;
    results: MaliciousRequest[] | null;
  };
  statsSummary: {
    loading: boolean;
    results: { request_unsafe_count: number } | null;
  };
  traceRecords: TraceRecordsStateType;
  traceDetail: {
    loading: boolean;
    results: TraceDetailType | null;
  };
  dashboardData: {
    loading: boolean;
    results: DashboardItem[] | null;
  };
  policyNameMapping: {
    loading: boolean;
    results: PolicyNameMapping | null;
  };
};
